import React, {useEffect, useState, useRef} from 'react';
import gsap from 'gsap';
import _ from 'lodash';
import './Situation.sass';
import StandardButton from "../../ui/Button/StandardButton";
import Button from "../../ui/Button/Button"
import ModalPopUp from "../../ui/PopUp/ModalPopUp";
import apiJSON from "../../../api/apiJSON";
import HotspotMap from "../../ui/HotspotMap/HotspotMap";
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";

const Situation = ({data, next, completed}) => {
        const [hotspots, setHotspots] = useState([]);
        const [scenario, setScenario] = useState(null);
        const [selectedTarget, setSelectedTarget] = useState(null);
        const [feedback, setFeedback] = useState(null);
        const [actions, setActions] = useState([]);
        const hotspotMap = useRef(null);

        useEffect(() => {
            const jsonData = apiJSON.get(data)
            const {scenarios} = jsonData; // get scenarios from JSON
            const scenario = scenarios[0];
            setScenario(scenario);
            setHotspots(scenario.hotspotMap.hotspots);
        }, []);


        useEffect(() => {
            gsap.to('.take-action-button', {x: 1100});
            gsap.from('.choice-panel', {x: 1100});
            gsap.set('.choice-panel', {opacity: 100, delay: 0.1});
        }, [actions])

        useEffect(() => {
            if (!selectedTarget) return;
            let rect = selectedTarget.getBoundingClientRect();
            let style = getHotspotData().style
            gsap.to(".info-box", {
                x: parseInt(style.left) + parseInt(style.width) + 10,
                y: parseInt(style.top),
                ease: "expo.out"
            })
            console.log("   rect: ", rect);
        }, [selectedTarget]);

        const getHotspotData = () => {
            if (!selectedTarget) return null;
            let hs = _.find(hotspots, {"id": selectedTarget.id})
            return hs;
        }


        const handleAction = () => {
            setActions(scenario.choiceSets[0].choices)
            gsap.to('.header-panel', {y: -500});
            setSelectedTarget(null);
        };

        const handleChoice = (feedback) => {
            setFeedback(feedback);
        };

        const handleContinue = () => {
            completed();
            next();
        };

        const selectHotspot = (event) => {
            if (event) {
                setSelectedTarget(event.target);
            } else {
                setSelectedTarget(null)
            }
        }

        return (
            <div
                className="situation-activity">
                {selectedTarget &&
                <div className={"info-box"} style={{

                }}>
                    <div className={"info-box-title"}>
                        {getHotspotData(selectedTarget).title}
                    </div>
                    <div className={"info-box-body"}>
                        {getHotspotData(selectedTarget).body}
                    </div>
                </div>}
                {scenario &&
                <HotspotMap data={scenario.hotspotMap}
                            ref={hotspotMap}
                            selected={selectHotspot}/>
                }

                {scenario && (
                    <div className="header-panel">
                        <div className="header-title">
                            {scenario.title}
                        </div>
                        <div className="header-body">
                            {scenario.body}
                        </div>
                    </div>
                )}
                {actions && (
                    <div className="choice-panel opacity-0">
                        {actions.map((choice, index) => (
                            <Button
                                key={index}
                                className="choice"
                                data={choice.label}
                                callback={() => handleChoice(choice.feedback)}
                            />

                        ))}
                    </div>
                )}
                {feedback && (
                        <EnhancedPopUp data={feedback}
                                       onHide={handleContinue}/>
                    )
                }
                <StandardButton
                    data={"Take Action"}
                    style ={{
                        "position":"absolute",
                        "right":0,
                        "bottom":"20px",
                        "zIndex":150
                    }}
                    callback={handleAction}
                />
            </div>
        );
    }
;

export default Situation;
